import { PaymentMethod } from './payment-method.type';

export const PAYMENT_METHODS: PaymentMethod[] = [
  {
    icon: 'kpay',
    title: 'account_payment-methods.credit-card',
    byQrcode: false,
  },
  {
    icon: 'kaspi',
    title: 'Kaspi QR',
    byQrcode: true,
    qrcodeConfig: {
      name: 'Kaspi',
      qrCodeStartData: 'https://kaspi.kz/pay/OFD_Kaztelecom?service_id=2602&3457=',
    },
  },
  {
    icon: 'halyk',
    title: 'Halyk QR',
    byQrcode: true,
    qrcodeConfig: {
      name: 'Halyk',
      qrCodeStartData: 'https://homebank.kz/payments/ofdKazakhtelecom?personalAccount=',
    },
  },
];
